import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmBoardRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
	name: 'servicedesk-boards',
	exact: true,
};
